export default function PHP_stmt_init() {
  return (
    <div>
      <h1>PHP_stmt_init</h1>
    </div>
  );
}
